import './style-boleto.css'

import * as _ from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

import { BankBilletInfo } from './BankBilletInfo'
import { PayerInfo } from './PayerInfo'


const CLASS_PRODUCT_TYPE = 3

const defineStatusProps = (status) => {

    let className;
    let label;

    if (status === 'OK') {
        className = 'var(--primary-color)'
        label = 'Aberto'

    } else if (status === 'PAID') {
        className = '#28a745'
        label = 'Pago'

    } else {
        className = '#dc3545'
        label = 'Vencido'
    }

    return {className: className, label: label}
}

const retrieveGuestsNames = (bankBillet) => {
    const guestNameList = []
    for (const invoice of bankBillet['invoices']) {
        if (!!invoice['invoiceAccount'] && !!invoice['invoiceAccount']['accounts']) {
            for (const account of invoice['invoiceAccount']['accounts']) {
                if (account['productRelease']['product']['type'] === CLASS_PRODUCT_TYPE) {
                    for (const guests of account['guests']) {
                        guestNameList.push(guests.name)
                    }
                }
            }
        }
    }
    const uniqueNames = _.uniq(guestNameList)
    return uniqueNames
}

export class BankBilletHeader extends React.Component {


    getSystemParameterByName = (paramName) => {
        const {systemParameters} = this.props
        const parameter = systemParameters.filter(({parameterId}) => parameterId === paramName)[0]


        if (!parameter)
            return ''

        return parameter.parameterValue || ''

    }


    render() {

        const props = this.props

        const {
            systemParameters,
            status
        } = props


        let labelProps = defineStatusProps(status)
        const guestNames = retrieveGuestsNames(props.empInvoiceBankBillet)

        return (
            <div className="card-boleto">
            <span style={{background: `${labelProps.className}`}} className="stiker-card">
                <span>{labelProps.label}</span>
            </span>
                <div className="div-header">
                    <div className="row">
                        <div className="logo-boleto"
                             style={{
                                 background: `url('${this.getSystemParameterByName('PARAM_ORGANIZATION_LOGO')}')`
                             }}>
                        </div>
                        <div className={'orgDetails'}>
                            <h1>Fatura</h1>
                            <address>
                                {this.getSystemParameterByName('PARAM_ORGANIZATION_FANTASY_NAME')}
                                <br/>
                                {this.getSystemParameterByName('PARAM_ORGANIZATION_ADDRESS')}
                                <br/>
                                ({this.getSystemParameterByName('PARAM_ORGANIZATION_DDD')})
                                {this.getSystemParameterByName('PARAM_ORGANIZATION_PHONE')}
                            </address>
                        </div>
                    </div>
                </div>

                <div className={'bbdetails' + ' dados'}>
                    <div className="row">
                        <div className="div-nome">
                            <PayerInfo empPerson={props.empInvoiceBankBillet.person}/>
                        </div>
                        <div className="cod-boleto">
                            <BankBilletInfo empInvoiceBankBillet={props.empInvoiceBankBillet} status={labelProps}/>
                        </div>
                    </div>
                    {guestNames.length> 0 ? <div className="div-guests">
                        Participantes: {guestNames.join(', ')}
                    </div> : null}
                </div>
            </div>
        )
    }


}

BankBilletHeader.PropTypes = {
    empInvoiceBankBillet: PropTypes.object.isRequired,
    systemParamters: PropTypes.object.isRequired,
    status: PropTypes.object.isRequired
}

export default BankBilletHeader



// WEBPACK FOOTER //
// ./src/components/BankBillet/BankBilletHeader.js